export default __webpack_public_path__ + "static/Research-d05c22e13accf89780fd04878412bf5d.webp";